import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';

export function CallbackPage() {
  const navigate = useNavigate();
  const { signinRedirectCallback } = useAuth();
  // React StrictMode double-invokes effects in development. Guard with a ref
  // so signinRedirectCallback() only fires once — the authorization code is
  // one-time-use, and a second concurrent call either gets "invalid_grant"
  // from Cognito or "No matching state found in storage", causing the catch
  // to navigate to '/' before the first call stores the user, breaking auth.
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    signinRedirectCallback()
      .then((user) => navigate(user?.state?.returnTo || '/', { replace: true }))
      .catch((err) => {
        console.error('Cognito sign-in callback failed', err);
        navigate('/', { replace: true });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
